if (typeof jQuery != "undefined") {
    ZZ.ToggleClassList = function(container) {
        var base = this;
        base.listElems = container.children("li:not(.no-toggle)");
        base.className = "open";

        base.assignListeners();
    };

    ZZ.ToggleClassList.prototype = {
        assignListeners: function() {
            var base = this;
            base.listElems.find(".header-table").on("click", function() {
                $(this)
                    .parent()
                    .toggleClass(base.className);
            });
        }
    };
}
